import React, { useCallback, useEffect, useState } from 'react';
import { reportsAPI } from '../../../services/api';
import useReport from '../shared/useReport';
import { scrollContentToTop } from '../../../utils/scroll';
import MedicineCataloguePanel, { EMPTY_FILTERS } from './MedicineCataloguePanel';
import MedicineProfileView from './MedicineProfileView';

// Medicine Profile: pick an item from the catalogue, then everything about it. The catalogue stays
// mounted (hidden) while a profile is open, so "Back to the catalogue" returns to exactly the list
// that was left: its filters, sort and page.

const MedicineProfileReport = () => {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [openId, setOpenId] = useState(null);
  const fetcher = useCallback(() => reportsAPI.getMedicineCatalogue(), []);
  const { data, loading } = useReport(fetcher);

  // Moving between the catalogue and a profile is a change of view, so it starts at the top.
  useEffect(() => { scrollContentToTop(); }, [openId]);

  return (
    <>
      <div hidden={Boolean(openId)}>
        <MedicineCataloguePanel data={data} loading={loading} filters={filters} setFilters={setFilters} onOpen={setOpenId} />
      </div>
      {openId && <MedicineProfileView key={openId} medicineId={openId} onBack={() => setOpenId(null)} />}
    </>
  );
};

export default MedicineProfileReport;
